import type { UserRole } from '../types/user';

export interface Permission {
  id: string;
  name: string;
}

export interface Permission1 {
  id: string;
  name: string;
}

// export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
//   super_admin: [
//     { id: 'manage_admins', name: 'Manage Administrators' },
//     { id: 'system_backup', name: 'System Backup & Restore' },
//     { id: 'create_projects', name: 'Create Projects' },
//     { id: 'delete_projects', name: 'Delete Projects' },
//     { id: 'manage_devices', name: 'Manage Devices' },
//     { id: 'view_analytics', name: 'View Analytics' },
//     { id: 'manage_users', name: 'Manage Users' },
//     { id: 'manage_system', name: 'Manage System Settings' },
//     { id: 'manage_security', name: 'Manage Security Settings' },
//     { id: 'view_audit_logs', name: 'View Audit Logs' },
//     { id: 'edit_projects', name: 'Edit Projects' },
//     { id: 'view_projects', name: 'View All Projects' },
//     { id: 'view_devices', name: 'View Devices' },
//     { id: 'export_analytics', name: 'Export Analytics' },
//     { id: 'assign_roles', name: 'Assign Roles' }
//   ],
//   admin: [
//     { id: 'create_projects', name: 'Create Projects' },
//     { id: 'edit_projects', name: 'Edit Projects' },
//     { id: 'view_projects', name: 'View All Projects' },
//     { id: 'manage_devices', name: 'Manage Devices' },
//     { id: 'view_devices', name: 'View Devices' },
//     { id: 'view_analytics', name: 'View Analytics' },
//     { id: 'export_analytics', name: 'Export Analytics' },
//     { id: 'manage_users', name: 'Manage Users' },
//     { id: 'assign_roles', name: 'Assign Roles' }
//   ],
//   manager: [
//     { id: 'create_projects', name: 'Create Projects' },
//     { id: 'edit_projects', name: 'Edit Projects' },
//     { id: 'view_projects', name: 'View All Projects' },
//     { id: 'view_devices', name: 'View Devices' },
//     { id: 'view_analytics', name: 'View Analytics' },
//     { id: 'export_analytics', name: 'Export Analytics' }
//   ],
//   user: [
//     { id: 'view_projects', name: 'View All Projects' },
//     { id: 'view_devices', name: 'View Devices' },
//     { id: 'view_analytics', name: 'View Analytics' }
//   ],
//   viewer: [
//     { id: 'view_projects', name: 'View All Projects' },
//     { id: 'view_analytics', name: 'View Analytics' }
//   ]
// }; 

export const ROLE_PERMISSIONS: any[] = [
  {
    "app_level_role_id": 1,
    "group_name": "super_admin",
    "display_name": "Super Admin",
    "permissions": {
      super_admin: [
        {
          id: 'manage_admins',
          name: 'Manage Administrators',
          value: true
        },
        {
          id: 'system_backup', name: 'System Backup & Restore',
          value: true
        },
        {
          id: 'create_projects', name: 'Create Projects',
          value: true
        },
        {
          id: 'delete_projects', name: 'Delete Projects',
          value: true
        },
        {
          id: 'manage_devices', name: 'Manage Devices',
          value: true
          },
        {
          id: 'view_analytics', name: 'View Analytics',
          value: true
        },
        {
          id: 'manage_users', name: 'Manage Users',
          value: true
        },
        {
          id: 'manage_system', name: 'Manage System Settings',
          value: true
        },
        // {
        //   id: 'manage_security', name: 'Manage Security Settings',
        //   value: true
        // },
        {
          id: 'manage_user_access', name: 'User Access Settings',
          value: true
        },
        {
          id: 'view_audit_logs', name: 'View Audit Logs',
          value: true
        },
        {
          id: 'edit_projects', name: 'Edit Projects',
          value: true
        },
        {
          id: 'view_projects', name: 'View All Projects',
          value: true
        },
        {
          id: 'view_devices', name: 'View Devices',
          value: true
        },
        {
          id: 'export_analytics', name: 'Export Analytics',
          value: true
        },
        {
              id: 'assign_roles', name: 'Assign Roles',
          value: true
        }
      ],
      update_date: "2025-08-29T10:00:00.000Z",
      created_date: "2025-08-29T10:00:00.000Z"
    },
    "is_active": true
  },
  {
    "app_level_role_id": 2,
    "group_name": "admin",
    "display_name": "Admin",
    "permissions": {
      admin: [
         {
          id: 'manage_admins',
          name: 'Manage Administrators',
          value: true
        },
        { id: 'create_projects', name: 'Create Projects',
          
          value: true
        },
        { id: 'edit_projects', name: 'Edit Projects',
          value: true
        },
        { id: 'view_projects', name: 'View All Projects',
          value: true
        },
        { id: 'manage_devices', name: 'Manage Devices',
          value: true
        },
        { id: 'view_devices', name: 'View Devices',
          value: true
        },
        { id: 'view_analytics', name: 'View Analytics',
          value: true
        },
        { id: 'export_analytics', name: 'Export Analytics',
          value: true
        },

          { id: 'manage_users', name: 'Manage Users',
          value: true
        },
        { id: 'assign_roles', name: 'Assign Roles',
          value: true
        }
      ],
      update_date: "2025-08-29T10:00:00.000Z",
      created_date: "2025-08-29T10:00:00.000Z"
    },
    "is_active": true
  },
  {
    "app_level_role_id": 3,
    "group_name": "manager",
    "display_name": "manager",
    "permissions": {

      manager: [
        { id: 'create_projects', name: 'Create Projects',
          value: true
        },
        { id: 'edit_projects', name: 'Edit Projects',
          value: true
        },
        { id: 'view_projects', name: 'View All Projects',
          value: true
        },
        { id: 'view_devices', name: 'View Devices',
          value: true
        },
        { id: 'view_analytics', name: 'View Analytics',
          value: true
        },
        { id: 'export_analytics', name: 'Export Analytics',
          value: true
        }
      ],
      update_date: "2025-08-29T10:00:00.000Z",
      created_date: "2025-08-29T10:00:00.000Z"
    },
    "is_active": true
  },
  {
    "app_level_role_id": 3,
    "group_name": "user",
    "display_name": "user",
    "permissions": {

      user: [
        { id: 'view_projects', name: 'View All Projects',
          value: true
        },
        { id: 'view_devices', name: 'View Devices',
          value: true
        },
        { id: 'view_analytics', name: 'View Analytics',
          value: true
        }
      ],
      update_date: "2025-08-29T10:00:00.000Z",
      created_date: "2025-08-29T10:00:00.000Z"
    },
    "is_active": true
  },
  {
    "app_level_role_id": 4,
    "group_name": "viewer",
    "display_name": "Viewer",
    "permissions": {
      viewer: [
          { id: 'view_projects', name: 'View All Projects',
          value: true
        },
        { id: 'view_analytics', name: 'View Analytics',
          value: true
        }
      ],
      update_date: "2025-08-29T10:00:00.000Z",
      created_date: "2025-08-29T10:00:00.000Z"
    },
    "is_active": true
  }

]
